import { state, style, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';

export interface IToastButton {
  id: string;
  title: string;
}

@Component({
  selector: 'vf-custom-toast',
  templateUrl: './custom-toast.component.html',
  styleUrls: ['./custom-toast.component.css'],
  animations: [
    trigger('flyInOut', [
      state('inactive', style({
        // display: 'none',
        opacity: 0
      })),
      state('active', style({})),
      state('removed', style({})),
    ])
  ]
})
export class CustomToastComponent extends Toast {

  options: any;
  constructor(protected toastrService: ToastrService, public toastPackage: ToastPackage) {
    super(toastrService, toastPackage);
  }

  action(btn: IToastButton): boolean {
    // tslint:disable-next-line: deprecation
    event.stopPropagation();
    this.toastPackage.triggerAction(btn);
    this.toastrService.clear();
    return false;
  }
}
